import React, { useState, useEffect } from "react";
import "./style.css";

import amc_logo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import pink_lines from "../../../../../assets/imgs/amc-domestico/Estelas_AMC.svg";

import { useLocation, useNavigate } from "react-router-dom";
import { IoMdExit } from "react-icons/io";
import { integrationService } from "./headerService";
import axios from "axios";

const CollectionHeader = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [viewBtnModal, setViewBtnModal] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const userName = localStorage.getItem("collection-user");
  const routes = [
    "/amc-domestico/collection",
    "/amc-domestico/collection/inspector",
    "/amc-domestico/collection/coordinator",
  ];

  const isLogin = routes.some((ruta) =>
    new RegExp(`^${ruta}/?$`).test(location.pathname)
  );

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  const logOut = async() => {
    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_COLLECTION}/user/logout`;
    const body = {
      user_id: localStorage.getItem("collection-email"),
      profile: localStorage.getItem("collection-profile"),
    };
    await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("collection-token")}`,
      },
    });
    localStorage.clear();
    sessionStorage.clear();
    navigate("/amc-domestico/collection/");
  };

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const showBtn = () => {
    const path = window.location.pathname;
    const latSegment = path.split("/").filter(Boolean).pop();

    if(latSegment === "clients") {
      setViewBtnModal(true);
    }
  }

  useEffect(() => {
    showBtn();
  }, []);

  return (
    <>
      <div className="amc-domestic-header">
        <div className="amc-domestic-header-img">
          <div className="logo">
            <img src={amc_logo} alt="Logo" />
          </div>
          <div className="lines_pink">
            <img src={pink_lines} alt="lines" />
          </div>
        </div>
        <div className="amc-domestic-header-hours">
          <div className="hours" style={isLogin ? { width: "100%" } : {}}>
            <span>{currentDate}</span>
            <span>{currentTime}</span>
          </div>
          {isLogin ? (
            ""
          ) : (
            <div className="user">
              <div className="username">
                <span>Usuario: {userName}</span>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenDropdown}
                >
                  ▼
                </span>
              </div>
              {openDropdown && (
                <div className="dropdownMenuHeaderCll">
                  <ul className="btn-cll-content">
                    {viewBtnModal && <li>
                      <button
                        type="button"
                        className="integration"
                        onClick={() => {
                          integrationService.open();
                          setTimeout(() => {
                            setOpenDropdown(false);
                          }, 1000);
                        }}
                      >
                        Integradores
                      </button>
                    </li>}
                    <li>
                      <button
                        type="button"
                        className="exit-btn"
                        onClick={logOut}
                      >
                        Cerrar sesion <IoMdExit />
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default CollectionHeader;
